define('controllers/edithotel',['require','nicEditlatest','services/htmlService'],function (require) {
    require('nicEditlatest');
    var HtmlService = require('services/htmlService');
    return function() {
        var hotelDetailArea = null;
        var AirportsJSON, airportList, txtPrimaryAirport, trStateProv, hdnState, hdnStateProvs, ddlState_Province, ddlCountry;
        //var htmlService = new HtmlService();

        window.fillStates = function (CountryID) {
            if (CountryID != null) {
                trStateProv.hide();
                var data = hdnStateProvs.value;
                eval("var JSON = " + data);
                var ddl = document.getElementById("ddlState_Province");
                ddl.innerHTML = "";

                var optionIndex = 0;
                for (var i = 0; i < JSON.length; i++) {
                    if (JSON[i].CountryID == CountryID) {
                        ddl.options[optionIndex] = new Option(JSON[i].Name, JSON[i].StateProvinceID);
                        optionIndex++;
                    }
                }
                trStateProv.show();
            }
            else {
                trStateProv.hide();
            }
        }

        window.selectState = function (stateName) {
            if (stateName == null) { //select option, if exists in state dropdown
                for (var i = 0; i < ddlState_Province.length; i++) {
                    if (ddlState_Province.options[i].innerHTML == hdnState.value) {
                        ddlState_Province.options[i].selected = true;
                        break;
                    }
                }
            }
            else { //put selected state in hdn field to retrieve on server
                hdnState.value = stateName;
            }
        }

        window.encodeContent = function() {
            var value = Utilities.htmlEncode(hotelDetailArea.instanceById('txtHotelDetail').getContent());
            $("#txtHotelDetail").val(value);
        }

        //function onDetailBoxChange(e) {
        //    console.log('changed');
        //    var box = hotelDetailArea.instanceById('txtHotelDetail');
        //    box.setContent(htmlService.cleanHtmlString(htmlService.cleanAttributes(box.getContent())));
        //}

        $(function () {
            hotelDetailArea = new nicEditor({ fullPanel: true, maxHeight: 400 }).panelInstance('txtHotelDetail', { hasPanel: true });
            //hotelDetailArea.addEvent('blur', onDetailBoxChange);

            //html encode content, since ValidateRequest="false" doesn't seem to be working as expected
            $('form').on('submit', encodeContent);
            $('#ddlHotelDetails').on('change', encodeContent);
        });
    };
});
